var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel-field" },
    [
      _c("label", { staticClass: "contactum-label" }, [
        _vm._v("\n    " + _vm._s(_vm.field.title) + "\n  ")
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.value,
            expression: "value"
          }
        ],
        attrs: { type: "text" },
        domProps: { value: _vm.value },
        on: {
          focusout: _vm.onfocusout,
          keyup: _vm.onkeyup,
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.value = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("merge_tags", {
        attrs: { filter: _vm.field.tag_filter },
        on: { insert: _vm.insertValue }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }